import { styled } from '../styles';

export default styled<'ol'>('ol')({
  listStyle: 'none',
  margin: 0,
  padding: 0,
});
